const Registration = {

    // PAGE HEADER
    "participant": "Participant",
    "organizer": "Organiser",
    "participant_header": "Participant Registration",
    "organizer_header": "Organiser Registration",

    // FIELDS
    'title': 'Title',
    'f_name': 'First Name',
    'm_name': 'Middle Name',
    'l_name': 'Last Name',
    'user_name': 'User Name',
    'email': 'Email',
    'password': 'Password',
    'phone': 'Phone',
    'gender': 'Gender',
    'alternate_phone': 'Alternate Phone (Social)',
    'emergency_phone': 'Emergency Phone',
    'emergency_phone_relative': 'Emergency Phone (Relative)',
    'dob': 'Date of Birth',
    'established_date': 'Established Date',
    'blood_group': 'Blood Group',
    'country': 'Country',
    'state': 'State',
    'city': 'City',
    'pincode': 'Pincode',
    'profile_photo': 'Profile Photo (Accept only .jpeg, .jpg, .png)',
    'address': 'Address',
    'shoe_size': 'Shoe Size',
    'tshirt_size': 'T-Shirt Size',
    'aadhar_no': 'Aadhaar Number',
    'upload_aadhar': 'Upload Aadhaar (Accept only .jpeg, .jpg, .png, .pdf)',
    'pan_no': 'PAN Number',
    'upload_pan': 'Upload PAN (Accept only .jpeg, .jpg, .png, .pdf)',
    'gst_no': 'GST Number',
    'upload_gst': 'Upload GST (Accept only .jpeg, .jpg, .png, .pdf)',
    'organization_name': 'Organisation Name',
    'organization_type': 'Organisation Type',
    'organization_details': 'Organisation Details',
    'organizer_details': 'Organiser Details',
    'documents': 'Documents',

    // FOOTER
    "footer_tagline": "Already have an account?",
    "back_to_login": "Back to Login",

    // TOAST
    "success_add": "Signed Up Successfully!!..",
    "success_add_organizer": "Thanks for creating your organizer profile! We're reviewing your details and will approve it within 24 hours or one business day.",
    "success_upload": "File Uploaded Successfully!!..",
    "success_google": "Signed in with Google! Please fill in the remaining required details",
    "failed_google": "Google sign-in failed",
    "server_error": "Server error!!..",
    "wrong": "Something went wrong!!..",

    // ERROR
    'error_title': 'Enter Title',
    'error_f_name': 'Enter First Name',
    'error_m_name': 'Enter Middle Name',
    'error_l_name': 'Enter Last Name',
    'error_user_name': 'Enter User Name',
    'error_email': 'Enter Email',
    'error_password': 'Enter Password',
    'error_phone': 'Enter Phone',
    'error_gender': 'Select Gender',
    'error_alternate_phone': 'Enter Alternate Phone (Social)',
    'error_emergency_phone': 'Enter Emergency Phone',
    'error_emergency_phone_relative': 'Enter Emergency Phone (Relative)',
    'error_dob': 'Choose Date of Birth',
    'error_established_date': 'Choose Established Date',
    'error_blood_group': 'Select Blood Group',
    'error_country': 'Select Country',
    'error_state': 'Select State',
    'error_city': 'Select City',
    'error_pincode': 'Enter Pincode',
    'error_profile_photo': 'Choose Profile Photo',
    'error_address': 'Enter Address',
    'error_shoe_size': 'Select Shoe Size',
    'error_tshirt_size': 'Select T-Shirt Size',
    'error_aadhar_no': 'Enter Aadhaar Number',
    'error_upload_aadhar': 'Choose Aadhaar Document',
    'error_pan_no': 'Enter PAN Number',
    'error_upload_pan': 'Choose PAN Document',
    'error_gst_no': 'Enter GST Number',
    'error_upload_gst': 'Choose GST Document',
    'error_organization_name': 'Enter Organisation Name',
    'error_organization_type': 'Select Organisation Type',

    'error_invalid_phone': 'Invalid Phone Number',
    'error_18_year': 'You must be at least 18 years old',

}

export default Registration;